import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { imgUrl } from "@/lib/api";

export const DemoBadge = ({ className = "" }) => (
  <span className={`font-mono-k text-[10px] uppercase tracking-widest px-2 py-1 bg-[#f7efe1] text-[#6b4a14] border border-[#ead9b9] ${className}`} data-testid="demo-badge">
    Demo / test
  </span>
);

export const FoundingBadge = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-1 font-mono-k text-[10px] uppercase tracking-widest px-2 py-1 bg-[#1f402b] text-[#f4e3bf] border border-[#1f402b] ${className}`} data-testid="founding-seller-badge">
    <Award size={11} /> Founding seller
  </span>
);

export function ListingCard({ item }) {
  const demo = item.is_demo || item.seller?.is_demo;
  return (
    <Link to={`/market/${item.id}`} className="group block img-zoom" data-testid="market-listing-card">
      <div className="relative overflow-hidden aspect-[4/3] bg-[#f4f0ea]">
        {item.images?.[0] && <img src={imgUrl(item.images[0])} alt={item.title} className="w-full h-full object-cover" loading="lazy" />}
        <div className="absolute top-3 left-3 flex flex-col items-start gap-1.5">
          {demo && <DemoBadge />}
          {(demo || item.seller?.founding_seller) && <FoundingBadge />}
        </div>
      </div>
      <p className="mt-4 eyebrow">{item.category} · {item.kind === "service" ? "Service" : "Product"}</p>
      <h3 className="mt-1.5 text-xl leading-snug text-[#1a261f] group-hover:text-[#1f402b]">{item.title}</h3>
      <div className="mt-2 flex items-center justify-between gap-3 text-sm">
        <span className="text-[#5a665e] truncate">{item.seller?.business_name}</span>
        {item.price && <span className="font-mono-k text-[13px] text-[#1f402b] whitespace-nowrap" data-testid="market-listing-price">{item.price}</span>}
      </div>
    </Link>
  );
}
